
import React, { useRef, useEffect, useState } from "react";

import './styles.css'

/*
el valor en triSwith
0: " "-> Falta
1: P ->Presente
2: L ->Licencia

dissabled:dissabled 
 */
const ForSwitch = ({ name, value, onChange, disabled, ...props }) => {
    // 
    const [label, setLabel] = useState('');
    //const defaultChecked = checked ? checked : false;
    //const [isChecked, setIsChecked] = useState(defaultChecked);
    //const [isChecked, setIsChecked] = useState(defaultChecked);

    useEffect (() => {
        //refreshToken();
        //setUser(authService.getCurrentUser());
        //console.log(user);
        setLabel(value)
    },[value]);
    //-----------------------------------
    const click_func =(e)=>{
      console.log("click_func")
      //---si esta deshabilitado retornamos
      if(disabled) return;
      //--- a cada click tenemos que hacer que cambie de valor
      //--- cambiamos a mayusculas
      //console.log(value)
      let new_value= value!==''? value.toUpperCase(value):'';

      switch( value ){
        case '': new_value='P'; break;
        case 'P': new_value='R'; break;
        case 'R': new_value='L'; break;
        case 'L': new_value=''; break;
        default: new_value=''
      }
      //---------actualizamos el estado
      setLabel(new_value)
      //------ preparamos para enviar afuera
      e.target.name = name
      e.target.value = new_value
      //console.log(e.target.value)
      onChange(e);
    }
    //--------------------------------
    const newClass=()=>{
      let sol = ''
      //switch(props.value){
      switch(value){
        case '': sol = 'ts1-falta'; break;
        case 'P': sol = 'ts1-presente'; break;
        case 'R': sol = 'ts1-retraso'; break;
        case 'L': sol = 'ts1-licencia'; break;
        default: sol=''
      }
      return sol
    }
    //-----------------------------------
    return (
      <>
        { 
          //JSON.stringify(value)
        }
      <div  className={ `ts1 ` + newClass() }
            disabled={ disabled }
            onClick={(e)=> click_func(e) } >
        <i></i>{ label }
      </div>
      </>
    );
  }
  
  export default ForSwitch;


  /*<NuCheckbox
      label=""
      name="chk_e1"
      value={this.state.form.chk_e1}
      onChange={ this.handleChangeForm }
    />*/